import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  imports: [MatSidenavModule, MatToolbarModule, MatIconModule, MatMenuModule],

  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  siteConfig = environment.siteConfig;
  readonly institutionName = this.siteConfig.institutionName;

  goHome() {
    window.location.href = '/';
  }
  goPortalPaciente() {
    window.open(this.siteConfig.navigation.portalPacienteUrl, '_blank');
  }
  navigateTo(url: string) {
    window.open(url, '_blank');
  }
}
